import React from 'react';
import { isEditor } from '../../utils/isEditor.js';
import DownPaymentCalculator from './DownPaymentCalculator.js';
import { FieldConfig } from './DownPaymentCalculator.utils.js';

var _attributes;
var DownPaymentCalculatorBlock = {
  Component: function Component(_ref) {
    var attrs = _ref.attrs;
    var homePrice = attrs.homePrice,
      percentage = attrs.percentage;
    var defaultValues = {
      homePrice: homePrice,
      percentage: percentage
    };
    return /*#__PURE__*/React.createElement(DownPaymentCalculator, {
      key: isEditor() ? JSON.stringify(defaultValues) : undefined,
      defaultValues: defaultValues
    });
  },
  metadata: {
    $schema: 'https://schemas.wp.org/trunk/block.json',
    version: '1.0',
    name: 'constellation/downpayment-calculator',
    title: 'Down Payment Calculator',
    description: 'Down payment calculator',
    icon: 'chart-line',
    keywords: ['down', 'payment', 'calculator'],
    supports: {
      customClassName: false,
      html: false
    },
    attributes: (_attributes = {}, _attributes[FieldConfig.homePrice.name] = {
      type: 'number',
      label: 'Default home price',
      default: 650000,
      control: 'number'
    }, _attributes[FieldConfig.percentage.name] = {
      type: 'number',
      label: 'Default down payment %',
      default: 10,
      control: 'number'
    }, _attributes)
  }
};
var DownPaymentCalculatorBlock$1 = DownPaymentCalculatorBlock;

export { DownPaymentCalculatorBlock$1 as default };
